import { AxiosInstance, default as Axios } from "axios";
import { getStore } from "../../MapStore2/web/client/utils/StateUtils";

interface SystemConfig {
    gisServerUrl: string;
    wizardPortalUrl: string;
}

interface AxiosInstanceWrapper {
    instance?: AxiosInstance;
}

export const apiWrapper: AxiosInstanceWrapper = {
    instance: undefined,
};

export const initAxiosInstance = async () => {
    apiWrapper.instance = Axios.create({
        baseURL: await getGisServerUrl(),
    });
    apiWrapper.instance?.interceptors.request.use((config) => {
        config.headers.ticket = getStore().getState().session.ticket;
        return config;
    });
};

const getGisServerUrlFromEnvironmentParams = async () => {
    const { data: gisServerUrlFromEnvironmentParams } = await Axios.get<string>(
        `${window.location.origin}/rest/config/gisServerUrl`
    ).catch(() => {
        return { data: undefined };
    });
    return gisServerUrlFromEnvironmentParams;
};

const getGisServerUrlFromSystemConfig = async () => {
    // we need to load systemConfig asynchronously so we can replace urls during installation process
    const { data: systemConfig } = await Axios.get<SystemConfig>("../../configs/systemConfig.json");
    return systemConfig.gisServerUrl;
};

const getGisServerUrl = async () => {
    const gisServerUrl = await getGisServerUrlFromEnvironmentParams();
    if (gisServerUrl) {
        return gisServerUrl;
    }

    return await getGisServerUrlFromSystemConfig();
};

export const updateHeaders = (headers: any) => {
    if (!apiWrapper.instance) return;

    const currentHeaders = apiWrapper.instance.defaults.headers;
    apiWrapper.instance.defaults.headers = {
        ...currentHeaders,
        ...headers,
    };
};
